import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.scss';
import Header from "./common/Header"
import Footer from './common/Footer'
import Login from "./view/login/Login";
import Dashboard from "./view/dashboard/Dashboard";
import Vehicles from "./view/vehicles/Vehicles";
import AddVehicle from "./view/vehicles/AddVehicle";
import AuctionList from "./view/auction/AuctionList";
import CreateAuction from "./view/auction/CreateAuction";
import EditAuction from "./view/auction/EditAuction";
import AuctionDetails from "./view/auction/AuctionDetails";
import AuctionInventoryList from "./view/auction/AuctionInventoryList";
import VehicleDetails from "./view/auction/VehicleDetails";



import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* Login as landing page - no header/footer */}
        <Route path="/" element={<Login />} />

        {/* Protected routes with header/footer */}
        <Route path="/dashboard" element={
          <div>
            <Header />
            <Dashboard />
            <Footer />
          </div>
        } />
        <Route path="/vehicles" element={
          <div>
            <Header />
            <Vehicles />
            <Footer />
          </div>
        } />
        <Route path="/vehicles/add" element={
          <div>
            <Header />
            <AddVehicle />
            <Footer />
          </div>
        } />
        <Route path="/auction" element={
          <div>
            <Header />
            <AuctionList />
            <Footer />
          </div>
        } />
        <Route path="/auction/create" element={
          <div>
            <Header />
            <CreateAuction />
            <Footer />
          </div>
        } />
        <Route path="/auction/edit/:auctionId" element={
          <div>
            <Header />
            <EditAuction />
            <Footer />
          </div>
        } />
        <Route path="/auction/details" element={
          <div>
            <Header />
            <AuctionDetails />
            <Footer />
          </div>
        } />
        <Route path="/auction/:auctionId/inventory" element={
          <div>
            <Header />
            <AuctionInventoryList />
            <Footer />
          </div>
        } />
        <Route path="/auction/inventory/:leadId/details" element={
          <div>
            <Header />
            <VehicleDetails />
            <Footer />
          </div>
        } />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </BrowserRouter>
  );
}

export default App;

